import React, { useState } from "react";
import styled from "styled-components";
import { Button, Input } from "components/bootstrap";
import { optionableLabel } from "components/configurationforms/FieldHelpers";
const FileContent = styled.span`
  vertical-align: middle;
`;
const EncryptedInlineBinaryField = ({
  field,
  title,
  typeName,
  dirty = false,
  onChange,
  value = {},
  autoFocus = false
}) => {
  const [fileName, setFileName] = useState(void 0);
  const [isResetted, setIsResetted] = useState(false);
  const [resettedFieldValue, setResettedFieldValue] = useState(void 0);
  const isValuePresent = field.is_encrypted ? value == null ? void 0 : value.is_set : !!value;
  const isRequired = !field.is_optional;
  const showReadOnly = !dirty && isValuePresent;
  const fieldId = `${typeName}-${title}`;
  const handleFileRead = (fileReader, file) => {
    const dataUrl = fileReader.result;
    if (dataUrl && typeof dataUrl === "string") {
      const dataString = dataUrl.replace(/^data:[\s\S]+\/[\s\S]+;base64,/, "");
      setFileName(file.name);
      if (field.is_encrypted) {
        onChange(title, { set_value: dataString });
      } else {
        onChange(title, dataString);
      }
    }
  };
  const handleReset = () => {
    setIsResetted(true);
    if (field.is_encrypted) {
      onChange(title, { delete_value: true });
    } else {
      setResettedFieldValue(value);
      onChange(title, "");
    }
  };
  const handleUndoReset = () => {
    setIsResetted(false);
    setFileName(void 0);
    if (field.is_encrypted) {
      onChange(title, { is_set: true }, false);
    } else {
      onChange(title, resettedFieldValue, false);
    }
  };
  const resetButton = () => {
    if (isValuePresent) {
      return /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: handleReset }, "Reset");
    }
    return null;
  };
  const undoResetButton = () => {
    if (!isResetted) return null;
    return /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: handleUndoReset }, "Undo Reset");
  };
  const removeButton = () => {
    if (fileName) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          type: "button",
          onClick: () => {
            setFileName(void 0);
            onChange(title, "");
          }
        },
        "Remove"
      );
    }
    return null;
  };
  const handleFileUpload = (file) => {
    const fileReader = new FileReader();
    fileReader.onloadend = (_) => handleFileRead(fileReader, file);
    if (file) {
      fileReader.readAsDataURL(file);
    }
  };
  const readOnlyFileInput = () => {
    if (field.is_encrypted) {
      return /* @__PURE__ */ React.createElement(
        Input,
        {
          id: fieldId,
          type: "password",
          name: `configuration[${title}]`,
          label: optionableLabel(field),
          required: isRequired,
          readOnly: true,
          help: field.description,
          value: "encrypted value",
          buttonAfter: resetButton(),
          autoFocus
        }
      );
    }
    return /* @__PURE__ */ React.createElement(
      Input,
      {
        id: fieldId,
        type: "text",
        name: `configuration[${title}]`,
        label: optionableLabel(field),
        required: isRequired,
        readOnly: true,
        help: field.description,
        value: "uploaded file content",
        buttonAfter: resetButton(),
        autoFocus
      }
    );
  };
  const fileInput = () => fileName ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: fieldId,
      name: `configuration[${title}]`,
      label: optionableLabel(field),
      required: isRequired,
      help: field.description,
      autoFocus,
      buttonAfter: /* @__PURE__ */ React.createElement(React.Fragment, null, removeButton(), undoResetButton())
    },
    /* @__PURE__ */ React.createElement(FileContent, null, fileName)
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      id: fieldId,
      type: "file",
      name: `configuration[${title}]`,
      label: optionableLabel(field),
      required: isRequired,
      help: field.description,
      buttonAfter: undoResetButton(),
      onChange: (e) => handleFileUpload(e.target.files[0]),
      autoFocus
    }
  );
  return showReadOnly ? readOnlyFileInput() : fileInput();
};
export default EncryptedInlineBinaryField;
